export default __webpack_public_path__ + "static/media/webCam.289cd75f.svg";